import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Row, Col, Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import classname from "classnames";

//i18n
import { withTranslation } from "react-i18next";

import { connect } from "react-redux";

const Navbar = props => {
  const [ui, setui] = useState(false);

  const [email, setemail] = useState(false);

  const [component, setcomponent] = useState(false);
  const [form, setform] = useState(false);
  const [table, settable] = useState(false);
  const [chart, setchart] = useState(false);
  const [icon, seticon] = useState(false);
  const [map, setmap] = useState(false);
  const [extra, setextra] = useState(false);
  const [auth, setauth] = useState(false);

  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active");
        }
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/dashboard"
                  >
                    <i className="ti-home me-2" />
                    {props.t("Inicio")} {props.menuOpen}
                  </Link>

                </li>

                {/* <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={e => {
                      e.preventDefault();
                      setcomponent(!component);
                    }}
                  >
                    <i className="ti-truck me-2"></i>
                    {props.t("Maquinaria")}
                  </Link>
                  <div
                    className={classname("dropdown-menu", { show: component })}
                  >
                    <Link to="/periodoconfig" className="dropdown-item">{props.t("Configurar periodos")}</Link>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          // setemail(!email);
                        }}
                      >
                        {props.t("Mano de obra directa")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: email })}
                      >
                        <Link to="/mod/ingresopuestos" className="dropdown-item">{props.t("Ingreso Puestos")}</Link>
                        <Link to="/mod/semanal" className="dropdown-item">{props.t("Desgloce tipo semana")}</Link>
                        <Link to="/mod/reportes" className="dropdown-item">{props.t("Reportes generales")}</Link>
                      </div>
                    </div>
                    
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          // setemail(!email);
                        }}
                      >
                        {props.t("Unidades")} <div className="arrow-down"></div>
                      </Link>
                      <div  className={classname("dropdown-menu", { show: email })} >
                        <Link to="/unidades/carga" className="dropdown-item">{props.t("Ingreso de unidades requeridas")}</Link>
                        <Link to="/unidades/resumenes" className="dropdown-item">{props.t("Resumenes")}</Link>
                        <Link to="/unidades/historicas" className="dropdown-item">{props.t("Historicas")}</Link>
                      </div>
                      
                    </div>
                    
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                        }}
                      >
                        {props.t("Tarifas")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: email })}
                      >
                        <Link to="/tarifas/configuraciones" className="dropdown-item">{props.t("Configuraciones")}</Link>
                        <Link to="/tarifas/reportes" className="dropdown-item">{props.t("Tarifa")}</Link>
                      </div>
                    </div>
                    
                    <div className="dropdown">
                        <Link
                          to="/#"
                          className="dropdown-item dropdown-toggle arrow-none"
                          onClick={e => {
                            e.preventDefault();
                          }}
                        >
                        {props.t("Mano de obra indirecta")} <div className="arrow-down"></div>
                      </Link>
                      <div className={classname("dropdown-menu")} >
                        <Link to="/moi/ingreso" className="dropdown-item">{props.t("Ingreso")}</Link>
                      
                        <Link to="/moi/reportes" className="dropdown-item">{props.t("Reporte")}</Link>
                      </div>
                    </div>
                    <div className="dropdown">
                        <Link
                          to="/#"
                          className="dropdown-item dropdown-toggle arrow-none"
                          onClick={e => {
                            e.preventDefault();
                          }}
                        >
                        {props.t("Combustible")} <div className="arrow-down"></div>
                      </Link>
                      <div className={classname("dropdown-menu")} >
                        <Link to="/combustible" className="dropdown-item">{props.t("Precios")}</Link>
                        
                        <Link to="/combustible/eficiencia" className="dropdown-item">{props.t("Eficiencias")}</Link>
                      </div>
                    </div>
                   
                      <Link to="/seguros" className="dropdown-item">{props.t("Seguros")}</Link>
                      <Link to="/depreciaciones" className="dropdown-item">{props.t("Depreciaciones")}</Link>
                      <Link to="/rentas" className="dropdown-item">{props.t("Rentas fijas y variables")}</Link>
                      <Link to="/comunicaciones" className="dropdown-item">{props.t("Comunicaciones")}</Link>
                      <Link to="/viaticos" className="dropdown-item">{props.t("Viaticos")}</Link>
                      <Link to="/sinternos" className="dropdown-item">{props.t("Servicio Internos")}</Link>
                      

                      <Link to="/repuestosylubricantes" className="dropdown-item">{props.t("Repuestos, lubricantes y llantas")}</Link>

                      
           
                     

                  </div>
                  
                </li> */}

                <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={e => {
                      e.preventDefault();
                      setcomponent(!component);
                    }}
                  >
                    <i className="ti-layout-tab me-2"></i>
                    {props.t("Digi-Forms")}
                  </Link>
                  <div
                    className={classname("dropdown-menu", { show: component })}
                  >
                    <Link to="/digiforms/mo" className="dropdown-item">{props.t("MO Agricola")}</Link>
                    <Link to="/digiforms/mq" className="dropdown-item">{props.t("MO maquinaria")}</Link>

                  </div>
                  
                </li>
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
);
